import React from 'react'
import {Link ,NavLink } from 'react-router-dom'
import "../css/categories.css"

function Categories() {
    const [visible1, setVisible1] = React.useState(false);
    return (
        <div className="category-row">
            <section id="animal-type">

                <div class="row  category-row">

                    <div class="feature-box col-lg-3 col-md-6 col-sm-6">
                        <Link className="animalType-link" to="/family/Dog">
                            <button class="animalType-btn">
                                <span className="animalType">
                                    <i class="pet-icon fa-solid fa-dog"></i>
                                    <span className="type">Dogs</span>
                                </span>
                            </button>
                        </Link>
                    </div>

                    <div class="feature-box col-lg-3 col-md-6 col-sm-6">
                        <Link className="animalType-link" to="/family/Cat">
                            <button class="animalType-btn">
                                <span className="animalType">
                                    <i class="pet-icon fa-solid fa-cat"></i>
                                    <span className="type">Cats</span>
                                </span>
                            </button>
                        </Link>
                    </div>

                    <div class="feature-box col-lg-3 col-md-6 col-sm-6">
                        <Link className="animalType-link" to="/family/Bird">
                            <button class="animalType-btn">
                                <span className="animalType">
                                    <i class="pet-icon fa-solid fa-dove"></i>
                                    <span className="type">Birds</span>
                                </span>
                            </button>
                        </Link>
                    </div>


                    <div class="feature-box col-lg-3 col-md-6 col-sm-6">
                        <button class="animalType-btn" onClick={() => {
                            setVisible1(!visible1)
                        }}>
                            <span className="animalType">
                                <i class="pet-icon fa-solid fa-paw"></i>
                                <span id="otherAnimal" className="type">More</span>
                            </span>
                        </button>

                        {visible1 &&
                          <>
                          <Link className="animalType-link" to="/family/Fish">
                                <button className="animalType-btn">
                                    <span className="animalType">
                                        <i class="pet-icon fa-solid fa-fish-fins"></i>
                                        <span id="otherAnimal" className="type">Fishes</span>
                                    </span>
                                </button>
                                </Link>

                                <Link className="animalType-link" to="/family/Turtle">

                                <button className="animalType-btn">
                                    <span className="animalType">
                                        <i class="pet-icon fa-solid fa-horse"></i>
                                        <span id="otherAnimal" className="type">Horses</span>
                                    </span>
                                </button>
                                </Link>

                            {/* <Link className="animalType-link" to="/family/Other">

                                <button className="animalType-btn">
                                    <span className="animalType">
                                        <i class="pet-icon fa-solid fa-paw"></i>
                                        <span id="otherAnimal" className="type">Others</span>
                                    </span>
                                </button>
                            </Link> */}
                          </>
                            
                        }

                    </div>
                </div>
            </section >
        </div >
    );
}

export default Categories